// frontend/src/components/chat/ToField.tsx
import { X } from 'lucide-react';
import type { DirectoryRow } from '../../services/api';
import { initialsOf } from './initials';

interface ToFieldProps {
  chips: DirectoryRow[];
  query: string;
  onQueryChange: (q: string) => void;
  onRemoveLast: () => void;
  onPickHighlighted: () => void;
  onRemove: (id: string) => void;
  error?: string | null;
}

export function ToField({
  chips,
  query,
  onQueryChange,
  onRemoveLast,
  onPickHighlighted,
  onRemove,
  error,
}: ToFieldProps) {
  return (
    <div className='border-b px-3 py-2'>
      <div className='flex flex-wrap items-center gap-1'>
        <span className='text-xs text-muted-foreground'>To:</span>
        {chips.map(chip => (
          <span
            key={chip.id}
            className='inline-flex items-center gap-1 rounded-full bg-muted px-1.5 py-0.5 text-xs'
          >
            <span className='flex h-4 w-4 items-center justify-center rounded-full bg-background text-[9px]'>
              {initialsOf(chip.label)}
            </span>
            {chip.label}
            <button
              type='button'
              aria-label={`Remove ${chip.label}`}
              onClick={() => onRemove(chip.id)}
            >
              <X className='h-3 w-3' />
            </button>
          </span>
        ))}
        <input
          aria-label='To'
          autoFocus
          value={query}
          onChange={e => onQueryChange(e.target.value)}
          onKeyDown={e => {
            if (e.key === 'Enter') {
              e.preventDefault();
              onPickHighlighted();
              return;
            }
            if (e.key === 'Backspace' && query === '') {
              e.preventDefault();
              onRemoveLast();
            }
          }}
          className='min-w-[6rem] flex-1 bg-transparent text-sm'
        />
      </div>
      {error && <p className='mt-1 text-xs text-destructive'>{error}</p>}
    </div>
  );
}
